<template>
  <div>
    <b-breadcrumb :items="items"></b-breadcrumb>
    <div
      v-if="busy"
      class="text-center"
      style="
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        z-index: 10000;
      "
    >
      <b-spinner label="Spinning"></b-spinner>
    </div>
    <b-row class="mx-0 mb-3">
      <b-col>
        <b-card
          v-if="step_2"
          title="Confirmation des factures commission"
          bg-variant="secondary"
          class
        >
          <b-row>
            <b-col lg="12" v-if="event !== null">
              <b-progress
                variant="success"
                :value="event.current_step"
                :max="event.total_steps"
                show-progress
                :animated="event.current_step !== event.total_steps"
                class="mb-3"
              ></b-progress>
            </b-col>
            <b-col lg="6">
              <b-card
                header="Factures envoyées par mail"
                bg-variant="secondary"
              >
                <b-table
                  v-if="confirm_response.emails"
                  striped
                  hover
                  :items="confirm_response.emails"
                  :fields="invoicesFields"
                >
                  <template v-slot:cell(factureID)="data">
                    <router-link
                      target="_blank"
                      :to="{
                        name: 'invoiceView',
                        params: { id: data.item.factureID },
                      }"
                      >{{ data.item.factureID }}</router-link
                    >
                  </template>
                </b-table>
              </b-card>
            </b-col>
            <b-col lg="6">
              <b-card class="mb-3" bg-variant="secondary" header="À imprimer">
                <object
                  style="width: 100%; height: 1000px"
                  :data="pdf_invoices"
                  type="application/pdf"
                >
                  <embed :src="pdf_invoices" type="application/pdf" />
                </object>
              </b-card>
            </b-col>
          </b-row>
        </b-card>
        <b-card
          v-if="!step_2"
          title="Factures commission"
          title-tag="h6"
          bg-variant="secondary"
          class
        >
          <div class="mb-3" v-if="loaded">
            <b-button
              @click="confirmInvoices"
              size="sm"
              variant="success"
              ><i class="fad fa-file-check"></i> Confirmer les
              factures</b-button
            >
            <b-button
              v-if="!noSelectedCreditors"
              @click="unselectAllCreditors()"
              size="sm"
              variant="secondary"
              class="ml-2"
              ><i class="fad fa-ballot-check"></i> Tout déselectionner</b-button
            >
            <b-button
              v-else
              @click="selectAllCreditors()"
              size="sm"
              variant="secondary"
              class="ml-2"
              ><i class="fad fa-ballot-check"></i> Tout sélectionner</b-button
            >
            <input
              @change="forceInvoicing()"
              type="checkbox"
              class="ml-3"
              v-model="forceInvoice"
            />
            <label class="ml-2"
              >Forcer la facturation des montants récupérés inférieurs à
              {{ twoDigits(commission_min) }} €
            </label>

            <b-button class="ml-3" size="sm" icon @click="sortByAmountUp()"
              ><i class="fad fa-sort-numeric-up"></i
            ></b-button>
            <b-button class="ml-3" size="sm" icon @click="sortByAmountDown()"
              ><i class="fad fa-sort-numeric-down"></i
            ></b-button>
            <b-button class="ml-3" size="sm" icon @click="sortByNameUp()"
              ><i class="fad fa-sort-alpha-up"></i
            ></b-button>
            <b-button class="ml-3" size="sm" icon @click="sortByNameDown()"
              ><i class="fad fa-sort-alpha-down"></i
            ></b-button>
            <b-button
              size="sm"
              disabled
              class="float-right"
              variant="outline-dark"
              >Total des commissions à récupérer :
              <strong>{{ totalCommission }} €</strong></b-button
            >
          </div>

          <div class="mb-3" id="factures-commission">
            <div v-html="html"></div>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import DateTime from "@/services/DateTime.js";
import invoices from "@/services/invoices.js";
export default {
  name: "invoicesCommission",
  components: {},
  data() {
    return {
      id: null,
      html: "",
      order_by: "nom",
      order_type: "asc",
      invoices: [],
      forceInvoice: false,
      totalCommission: 0,
      noSelectedCreditors: false,
      loaded: false,
      filter: "",
      poll_event: null,
      event: null,
      event_id: null,
      busy: true,
      commission_min: 0,
      confirm_response: { emails: [], to_print: [] },
      step_2: false,
      items: [
        {
          text: "Gestion",
          to: { name: "home" },
        },
        {
          text: "Paiements",
          to: { name: "payments" },
        },
      ],
      invoicesFields: [
        {
          key: "factureID",
          label: "#",
        },
        {
          key: "creancier",
          label: "Créancier",
        },
        {
          key: "solde",
          label: "Montant TVAC",
          class: "text-right",
          formatter: (value) => this.twoDigits(value) + " €",
        },
      ],
    };
  },

  created() {
    if (this.$route.params.id) {
      this.id = this.$route.params.id;
    }
    this.load();
    document.addEventListener("click", (e) => {
      if (e.target && e.target.id.substring(0, 8) == "payement") {
        this.totalCom();
        let value = true;
        let payments = document.querySelectorAll(
          "." + e.target.getAttribute("class")
        );
        payments.forEach((el) => {
          if (!el.checked) {
            value = false;
          }
        });
        let creancier = document.querySelector(
          "#" + e.target.getAttribute("class")
        );
        creancier.checked = value;
      } else if (e.target && e.target.id.substring(0, 9) == "creancier") {
        let payments = document.querySelectorAll("." + e.target.id);
        if (e.target.checked) {
          payments.forEach((el) => (el.checked = true));
        } else {
          payments.forEach((el) => (el.checked = false));
        }
      }
    });
  },
  destroyed() {
    clearInterval(this.poll_event);
  },
  computed: {
    pdf_invoices() {
      return (
        this.$store.getters.url +
        "/invoices/pdf?ids=" +
        JSON.stringify(this.confirm_response.to_print.map((x) => x.factureID)) +
        "&token=" +
        encodeURIComponent(localStorage.getItem("vue-token"))
      );
    },
  },

  methods: {
    totalCom() {
      let payments = document.querySelectorAll('[id^="payement"]');
      let total = 0;
      payments.forEach((payment) => {
        if (payment.checked) {
          total = total + parseFloat(payment.getAttribute("data-com"));
        }
      });
      this.totalCommission = total.toFixed(2);
    },
    selectAllCreditors() {
      let payments = document.querySelectorAll('[id^="payement"]');
      payments.forEach((payment) => {
        payment.checked = true;
      });
      payments = document.querySelectorAll('[id^="creancier"]');
      payments.forEach((payment) => {
        payment.checked = true;
      });
      this.noSelectedCreditors = false;
      this.totalCom();
    },
    unselectAllCreditors() {
      let payments = document.querySelectorAll('[id^="payement"]');
      payments.forEach((payment) => {
        payment.checked = false;
      });
      payments = document.querySelectorAll('[id^="creancier"]');
      payments.forEach((payment) => {
        payment.checked = false;
      });
      this.noSelectedCreditors = true;
      this.totalCom();
    },
    sortByAmountUp() {
      var indexes = document.querySelectorAll("[data-sortnumber]");
      var indexesArray = Array.from(indexes);
      let sorted = indexesArray.sort((a, b) => parseFloat(a.dataset.sortnumber) > parseFloat(b.dataset.sortnumber));
      document.getElementById("factures-commission").innerHTML = "";
      sorted.forEach((e) => document.querySelector("#factures-commission").appendChild(e));
    },
    sortByAmountDown() {
      var indexes = document.querySelectorAll("[data-sortnumber]");
      var indexesArray = Array.from(indexes);
      let sorted = indexesArray.sort((a, b) => parseFloat(a.dataset.sortnumber) < parseFloat(b.dataset.sortnumber));
      document.getElementById("factures-commission").innerHTML = "";
      sorted.forEach((e) => document.querySelector("#factures-commission").appendChild(e));
    },
    sortByNameUp() {
       var indexes = document.querySelectorAll("[data-sortalpha]");
      var indexesArray = Array.from(indexes);
      let sorted = indexesArray.sort((a, b) => a.dataset.sortalpha < b.dataset.sortalpha);
      document.getElementById("factures-commission").innerHTML = "";
      sorted.forEach((e) => document.querySelector("#factures-commission").appendChild(e));
    },
    sortByNameDown() {
       var indexes = document.querySelectorAll("[data-sortalpha]");
      var indexesArray = Array.from(indexes);
      let sorted = indexesArray.sort((a, b) => a.dataset.sortalpha > b.dataset.sortalpha);
      document.getElementById("factures-commission").innerHTML = "";
      sorted.forEach((e) => document.querySelector("#factures-commission").appendChild(e));
    },

    forceInvoicing() {
      let creanciers = document.querySelectorAll('[id^="creancier"]');
      if (this.forceInvoice) {
        creanciers.forEach((el) => {
          let com = parseFloat(el.getAttribute("data-comtotal"));
          if (com < this.commission_min) {
            el.checked = true;
            let payments = document.querySelectorAll("." + el.id);
            payments.forEach((payment) => {
              payment.checked = true;
            });
          }
        });
      } else {
        creanciers.forEach((el) => {
          let com = parseFloat(el.getAttribute("data-comtotal"));
          if (com < this.commission_min) {
            el.checked = false;
            let payments = document.querySelectorAll("." + el.id);
            payments.forEach((payment) => {
              payment.checked = false;
            });
          }
        });
      }
      this.totalCom();
    },
    
    confirmInvoices() {
      this.step_2 = true;
      let selected = [];
      let creanciers = document.querySelectorAll('[id^="creancier"]');
      creanciers.forEach(creancier => {
        let payments = document.querySelectorAll('.' + creancier.getAttribute('id'));
        let arr = [];
        payments.forEach(payment => {
          if(payment.checked) {
            arr.push(parseInt(payment.getAttribute('id').substring(9)));
          }
        })
        if(arr.length) {
          selected.push({
            creancierID: parseInt(creancier.getAttribute('id').substring(10)),
            paiements: arr
          })
        }
      })
     
      invoices
        .confirm_commission(
          selected
        )
        .then((response) => {
          if (response.data.success) {
            this.event_id = response.data.eventID;
            this.poll_event = setInterval(() => {
              this.event = this.$store.getters.job(this.event_id);
              if (
                this.event !== null &&
                this.event.response !== null &&
                this.event.response.data !== undefined
              ) {
                this.confirm_response =
                  this.event.response.data || this.confirm_response;
                if (this.event.status == "finished") {
                  clearInterval(this.poll_event);
                  this.poll_event = null;
                }
              }
            }, 1000);
          }
        })
        .catch(() => {});
    },
    load() {
      this.busy = true;
      invoices.commission(this.id).then((response) => {
        if (response.data.success) {
          this.invoices = response.data.data;
          this.loaded = true;
          this.html = response.data.html;
          this.commission_min = parseFloat(response.data.commission_min);
          this.totalCommission = parseFloat(response.data.total_commission);
          this.items.push({
            text: this.id
              ? "Facture commission pour " + this.invoices[0].creancier.nom_soc
              : "Factures commission",
            active: true,
          });
        }
        this.busy = false;
      });
    },

    toDate(d) {
      return DateTime.humanDate(d);
    },
    twoDigits(value) {
      return Number(value).toFixed(2);
    },
  },
};
</script>

<style lang="scss" scoped>
.table-payments {
}
</style>